var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/promise-native-constructor.js
// module id = 55
// module chunks = 0 1